export default __webpack_public_path__ + "static/media/Gabriola.84518584.ttf";